import React from "react";
import { Button } from "@/components/ui/button";
import { designTokens, cn } from "@/styles/designTokens";

/**
 * GradientButton - Reusable gradient button component
 * Automatically applies consistent gradient styling
 *
 * @param {string} variant - Button style: 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'purple'
 * @param {React.ReactNode} children - Button content
 * @param {string} size - Button size from shadcn/ui
 * @param {boolean} disabled - Disabled state
 * @param {Function} onClick - Click handler
 */
export const GradientButton = ({
  variant = "primary",
  children,
  size = "default",
  disabled = false,
  onClick,
  className = "",
  ...props
}) => {
  const gradientClass =
    designTokens.buttons[variant] || designTokens.buttons.primary;

  return (
    <Button
      size={size}
      disabled={disabled}
      onClick={onClick}
      className={cn(gradientClass, className)}
      {...props}
    >
      {children}
    </Button>
  );
};

/**
 * Button variant shortcuts for common use cases
 */
export const PrimaryButton = (props) => (
  <GradientButton variant="primary" {...props} />
);
export const SuccessButton = (props) => (
  <GradientButton variant="success" {...props} />
);
export const DangerButton = (props) => (
  <GradientButton variant="danger" {...props} />
);
export const WarningButton = (props) => (
  <GradientButton variant="warning" {...props} />
);
export const InfoButton = (props) => (
  <GradientButton variant="info" {...props} />
);
export const PurpleButton = (props) => (
  <GradientButton variant="purple" {...props} />
);

export default GradientButton;
